module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-d1b91d07.png";